import { Query, QueryOrderDirection, BloodGlucoseSession } from "../misc/api/apiTypes";
import { BloodGlucoseActionType, BloodGlucoseAction, SortBloodGlucoseSessionsAction } from "./BloodGlucoseActions";
import { getQueryFilters, getQuerySorting } from "../misc/components/queryTable/ReducerUtilities";

export interface BloodGlucoseListState {
    sessionQuery: Query<BloodGlucoseSession>;
    sessionFilterQuery: Query<BloodGlucoseSession>;
}

export const initialListState: BloodGlucoseListState = {
    sessionQuery: {
        Page: {
            Current: 1,
            Length: 10,
        },
        Order: {
            Member: 'ReceivedDateTime',
            Direction: QueryOrderDirection.Descending,
        },
        Filters: [],
    },
    sessionFilterQuery: {
        Members: ['Name', 'ConfigurationTechnician', 'UploadTechnician', 'DeviceSerialNumber', 'Status'],
        Order: {
            Member: 'Name',
            Direction: QueryOrderDirection.Ascending,
        },
        Filters: [],
        Distinct: true,
    },
}

export function bloodGlucoseListReducer(state: BloodGlucoseListState = initialListState, action: BloodGlucoseAction): BloodGlucoseListState {
    switch (action.type) {
        case BloodGlucoseActionType.ClearBloodGlucoseSessions:
            return {
                ...state,
                sessionQuery: {
                    ...state.sessionQuery,
                    Data: null,
                },
            };
        case BloodGlucoseActionType.SortBloodGlucoseSessions:
            return sortBloodGlucoseSessions(state, action);
        case BloodGlucoseActionType.PageBloodGlucoseSessions:
            return {
                ...state,
                sessionQuery: {
                    ...state.sessionQuery,
                    Page: {
                        ...state.sessionQuery.Page,
                        Current: action.page,
                    }
                },
            };
        case BloodGlucoseActionType.FilterBloodGlucoseSessions:
            const filters = getQueryFilters(state.sessionQuery, action.member, action.condition, action.value);

            return {
                ...state,
                sessionQuery: {
                    ...state.sessionQuery,
                    Filters: filters,
                    Page: {
                        ...state.sessionQuery.Page,
                        Current: 1,
                    }
                },
            };
        case BloodGlucoseActionType.ClearAllSessionFilters:
            return {
                ...state,
                sessionQuery: {
                    ...state.sessionQuery,
                    Filters: [],
                },
            };
        case BloodGlucoseActionType.LoadBloodGlucoseSessions:
            return {
                ...state,
                sessionQuery: action.data,
            };
        case BloodGlucoseActionType.LoadSessionFilter:
            return {
                ...state,
                sessionFilterQuery: action.query,
            };
        default:
            return state;
    }
}

function sortBloodGlucoseSessions(state: BloodGlucoseListState, action: SortBloodGlucoseSessionsAction) {
    const order = getQuerySorting(state.sessionQuery, action.member);
    return {
        ...state,
        sessionQuery: {
            ...state.sessionQuery,
            Order: order,
        }
    };
}
